import React, { useState } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'

import { Modal, Button, Typography } from '../../../../components'
import {
  ProductStatus,
  ProductStatusListForSelect
} from '../../../../constants/product'
import {
  Form,
  FormBody,
  FormGroupContainer
} from '../../../../components/Form/styles'
import Input from '../../../../components/Form/Input'
import Select from '../../../../components/Form/Select'
import Checkbox from '../../../../components/Form/Checkbox'
import { maskToCurrency } from '../../../../utils/maskFunctions/maskToCurrency'
import ecbrApi from '../../../../services/ecbrApi'
import ErrorMessage from '../../../../components/Form/ErrorMessage'
import { errorResponseStatusHandler } from '../../../../utils/handlers/errorResponseStatusHandler'
import { currencyToNumber } from '../../../../utils/currencyToNumber'
import { realToCents } from '../../../../helpers/realToCents'

const initialValues = {
  code: '',
  name: '',
  amount: '',
  maxInstallments: '',
  description: '',
  status: ProductStatus.AVAILABLE,
  isBankSlip: true,
  isCreditCard: true,
  // isDebitCard: true,
  isPix: true
  // imageId: 0
}

const formSchema = Yup.object().shape({
  code: Yup.string().required('Campo obrigatório'),
  name: Yup.string().required('Campo obrigatório'),
  amount: Yup.number()
    .required('Campo obrigatório')
    .test('is-currency-real', 'Valor inválido', (_, { originalValue }) => {
      // Using Regex to validate currency real. Ex: R$ 1.112,22
      const regex = /^(R\$\s?)?(([1-9]\d{0,2}(\.\d{3})*)|0)?(,\d{1,2})?$/
      return regex.test(originalValue)
    })
    .transform((_, value) => currencyToNumber(value))
    .min(0.01, 'Valor inválido'),
  maxInstallments: Yup.number()
    .transform((_, obj) => obj?.value ?? undefined)
    .required('Campo obrigatório'),
  description: Yup.string().required('Campo obrigatório'),
  status: Yup.string()
    .transform((_, obj) => obj?.value ?? undefined)
    .required('Campo obrigatório'),
  isBankSlip: Yup.boolean().required('Campo obrigatório'),
  isCreditCard: Yup.boolean().required('Campo obrigatório'),
  // isDebitCard: Yup.boolean().required('Campo obrigatório'),
  isPix: Yup.boolean().required('Campo obrigatório')
  // imageId: Yup.number().required('Campo obrigatório')
})

const installmentsListForSelect = [...Array(12).entries()].map((_, index) => ({
  value: index + 1,
  label: `${index + 1}x`
}))

const CertificateModal = ({ onHide, ...rest }) => {
  const [error, setError] = useState('')

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true)
      const { amount, status, maxInstallments, ...restValues } = values
      const certificate = {
        ...restValues,
        amount: realToCents(currencyToNumber(amount)),
        status: status.value,
        maxInstallments: maxInstallments.value
        // imageId: values.imageId
      }

      await ecbrApi.products.create(certificate)
      onHide?.(false)
    } catch (err) {
      errorResponseStatusHandler(err, setError)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal onHide={onHide} exitOnBackdropClick={false} {...rest}>
      <Modal.Header closeButton>
        <Modal.Title>Novo Certificado</Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={formSchema}
        enableReinitialize
      >
        {({ handleSubmit }) => (
          <>
            <Modal.Body>
              <Form>
                <FormBody>
                  <Typography type="text" spacing="0 0 1rem 0" align="center">
                    Dados do Certificado
                  </Typography>
                  <FormGroupContainer>
                    <Input
                      type="text"
                      name="code"
                      label="Código"
                      placeholder="Código do certificado"
                    />
                    <Select
                      name="status"
                      label="Status"
                      options={ProductStatusListForSelect}
                      optionValue="value"
                      optionLabel="label"
                    />
                  </FormGroupContainer>
                  <Input
                    type="text"
                    name="name"
                    label="Nome"
                    placeholder="Nome do certificado"
                  />
                  <FormGroupContainer>
                    <Input
                      type="text"
                      name="amount"
                      label="Valor"
                      placeholder="Valor do certificado"
                      mask="R$ 9999999999"
                      alwaysShowMask={false}
                      beforeMaskedStateChange={maskToCurrency}
                    />
                    <Select
                      name="maxInstallments"
                      label="Número de parcelas"
                      options={installmentsListForSelect}
                      optionValue="value"
                      optionLabel="label"
                    />
                  </FormGroupContainer>
                  <Input
                    type="text"
                    name="description"
                    label="Descrição"
                    placeholder="Descrição do certificado"
                  />
                  <FormGroupContainer>
                    <Checkbox name="isCreditCard" label="Cartão de crédito" />
                    {/* <Checkbox name="isDebitCard" label="Cartão de débito" /> */}
                    <Checkbox name="isBankSlip" label="Boleto bancário" />
                    <Checkbox name="isPix" label="Pix" />
                  </FormGroupContainer>
                  {error && <ErrorMessage>{error}</ErrorMessage>}
                </FormBody>
              </Form>
            </Modal.Body>
            <Modal.Footer align="center">
              <Button
                text="Cancelar"
                variant="outlined"
                width="200px"
                onClick={() => onHide?.(false)}
              />
              <Button
                text="Salvar"
                variant="primary"
                width="200px"
                onClick={handleSubmit}
              />
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default CertificateModal
